module.exports = __webpack_public_path__ + "6fc013c9d1007c352313f021a700bb66.svg";